const PLATFORM_STORAGE_KEY = 'platform_auth_platform';
const INIT_DATA_STORAGE_KEY = 'platform_auth_init_data';

function getCookie(name) {
    const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : null;
}

function setCookie(name, value) {
    document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=86400; SameSite=Lax`;
}

export function savePlatformAuth(platform, initData) {
    if (!platform || !initData) return;
    localStorage.setItem(PLATFORM_STORAGE_KEY, platform);
    localStorage.setItem(INIT_DATA_STORAGE_KEY, initData);
    setCookie(PLATFORM_STORAGE_KEY, platform);
    setCookie(INIT_DATA_STORAGE_KEY, initData);
}

function getStoredPlatformAuth() {
    const platform = getCookie(PLATFORM_STORAGE_KEY) || localStorage.getItem(PLATFORM_STORAGE_KEY);
    const initData = getCookie(INIT_DATA_STORAGE_KEY) || localStorage.getItem(INIT_DATA_STORAGE_KEY);
    return platform && initData ? { platform, initData } : { platform: null, initData: null };
}

/**
 * Return native messenger authentication data, or the signed handoff saved
 * while the PWA was installed from Telegram/MAX.
 */
export function getNativePlatformAuth() {
    const telegramInitData = window.Telegram?.WebApp?.initData;
    if (telegramInitData) {
        return { platform: 'telegram', initData: telegramInitData };
    }

    const maxInitData = window.WebApp?.initData;
    if (maxInitData) {
        return { platform: 'max', initData: maxInitData };
    }

    return getStoredPlatformAuth();
}

export function isApiRequest(url) {
    const apiUrl = process.env.REACT_APP_API_URL;
    if (apiUrl) {
        try {
            const requestUrl = new URL(url, window.location.origin);
            const configuredApiUrl = new URL(apiUrl, window.location.origin);
            const configuredPath = configuredApiUrl.pathname.replace(/\/$/, '');
            const hasConfiguredPath = configuredPath && configuredPath !== '/';

            return requestUrl.origin === configuredApiUrl.origin
                && (!hasConfiguredPath
                    || requestUrl.pathname === configuredPath
                    || requestUrl.pathname.startsWith(`${configuredPath}/`));
        } catch {
            return false;
        }
    }

    try {
        return new URL(url, window.location.origin).pathname.startsWith('/api/');
    } catch {
        return false;
    }
}
